import React from 'react';
import { Link } from 'react-router-dom';
import { offices } from '../data/mockData';
import { Button } from '../components/ui/button';
import { ChevronRight, MapPin, Phone, Mail, Building } from 'lucide-react';
import SEO from '../components/SEO';

const Offices = () => {
  return (
    <div>
      <SEO 
        title="Our Office Locations - Security Services in Miami, Florida"
        description="Visit our Miami office at 12750 NW 17 St Suite 207, Miami, FL 33182. Contact us at 888-356-0005 or miami@busecurity.com for professional security services."
        keywords="Bu Security office, security company Miami, security office location, Miami security headquarters, contact security company Miami"
      />
      {/* Hero Section */}
      <section className="relative h-[300px] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&h=600&fit=crop')`,
          }}
        />
        <div className="absolute inset-0 bg-[#1e3a52]/80" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 w-full">
          <div className="flex items-center gap-2 text-sm text-gray-300 mb-4">
            <Link to="/" className="hover:text-[#5ba4c8]">Home</Link>
            <ChevronRight size={16} />
            <span className="text-[#5ba4c8]">Offices</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white uppercase tracking-wider">
            Our Offices
          </h1>
          <p className="text-gray-300 mt-4 max-w-2xl">
            Find a Bu Security location near you
          </p>
        </div>
      </section>

      {/* Offices Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {offices.map((office, index) => (
              <div 
                key={index} 
                className={`bg-white rounded-lg shadow-lg p-8 ${
                  office.isHeadquarters ? 'ring-2 ring-[#5ba4c8]' : ''
                }`}
              >
                {office.isHeadquarters && (
                  <span className="inline-block bg-[#5ba4c8] text-white text-xs px-3 py-1 rounded-full mb-4">
                    Headquarters
                  </span>
                )}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-[#5ba4c8]/10 rounded-full flex items-center justify-center">
                    <Building size={24} className="text-[#5ba4c8]" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1e3a52]">{office.city}</h3>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-start gap-3 text-gray-600">
                    <MapPin size={18} className="text-[#5ba4c8] mt-1" />
                    <span>{office.address}</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <Phone size={18} className="text-[#5ba4c8]" />
                    <a href={`tel:${office.phone}`} className="hover:text-[#5ba4c8]">
                      {office.phone}
                    </a>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <Mail size={18} className="text-[#5ba4c8]" />
                    <a href={`mailto:${office.email}`} className="hover:text-[#5ba4c8] text-sm">
                      {office.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-[#1e3a52] mb-8">Service Areas</h2>
          <div className="bg-gray-200 rounded-lg h-[400px] flex items-center justify-center">
            <div className="text-center">
              <MapPin size={48} className="text-[#5ba4c8] mx-auto mb-4" />
              <p className="text-gray-600">Serving all of South Florida</p>
              <p className="text-sm text-gray-500 mt-2">Miami</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#1e3a52]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-gray-300 mb-8">
            Contact your nearest office or request a quote online
          </p>
          <Link to="/quote">
            <Button className="bg-[#5ba4c8] hover:bg-[#4a93b7] text-white px-8 py-3">
              Request a Quote
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Offices;
